import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import MigrationModalBody from "./MigrationModalBody"

import "./MigrationModal.css"
import "/src/assets/css/polices.css";

const MigrationModal = NiceModal.create(({ title, data}) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const form = { title: title, data: data? data : {}}
    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({idIconModal:"close_modal_container"})} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>

             <MigrationModalBody form={form}></MigrationModalBody>

        </SideModal >
    )
});

export default MigrationModal;